import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { history, fetchWrapper } from "../_helpers";

const initialData = {
  facilityID: 0,
  createdBy: 1,
  type_KioskLockdownModel: [
    {
      kiosksID: 0,
      lockDownActive: 0,
    },
  ],
  type_MenuAccessLockdownModel: [
    {
      lockdownSettingID: 0,
      lockDownActive: 0,
    },
  ],
};

// create slice

const name = "lockDown";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports

export const lockDownActions = { ...slice.actions, ...extraActions };
export const lockDownReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    // initialize state
    lockdowndataList: initialData,
    unlockList: [],
    lockdownList: [],
    lockdownStatus: [],
    loading: false,
    error: null,
  };
}

function createReducers() {
  return {
    clearUpdateLockdownStatus,
    setLockDownData,
  };
  // clear the response
  function clearUpdateLockdownStatus(state) {
    state.lockdownStatus = [];
  }

  function setLockDownData(state, action) {
    state.lockdowndataList = action.payload && action.payload;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/Lockdown`;
  return {
    LoadMenuAccessLockUnlockList: LoadMenuAccessLockUnlockList(),
    LoadKioskLockdownList: LoadKioskLockdownList(),
    UpdateLockdownStatus: UpdateLockdownStatus(),
  };

  function LoadMenuAccessLockUnlockList() {
    return createAsyncThunk(
      `${name}/LoadMenuAccessLockUnlockList`,
      async (facilityID) =>
        await fetchWrapper.get(
          `${baseUrl}/LoadMenuAccessLockUnlockList?facilityID=${facilityID}`
        )
    );
  }
  function LoadKioskLockdownList() {
    return createAsyncThunk(
      `${name}/LoadKioskLockdownList`,
      async ({ facilityID, sortBy, PageNo , RowCountPerPage}) =>
        await fetchWrapper.get(
          `${baseUrl}/LoadKioskLockdownList?facilityID=${facilityID}&sortBy=${sortBy}&PageNo=${PageNo}&RowCountPerPage=${RowCountPerPage}`
        )
    );
  }
  function UpdateLockdownStatus() {
    return createAsyncThunk(
      `${name}/UpdateLockdownStatus`,
      async (params) =>
        await fetchWrapper.post(`${baseUrl}/UpdateLockdownStatus`, params)
    );
  }
}

function createExtraReducers(builder) {
  builder
    //LoadMenuAccessLockUnlockList
    .addCase(extraActions.LoadMenuAccessLockUnlockList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadMenuAccessLockUnlockList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.unlockList = action.payload;
      }
    )
    .addCase(
      extraActions.LoadMenuAccessLockUnlockList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    /// LoadKioskLockdownList
    .addCase(extraActions.LoadKioskLockdownList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadKioskLockdownList.fulfilled, (state, action) => {
      state.loading = false;
      state.lockdownList = action.payload?.DataList;
    })
    .addCase(extraActions.LoadKioskLockdownList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    /// status response
    .addCase(extraActions.UpdateLockdownStatus.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.UpdateLockdownStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.lockdownStatus = action.payload;
    })
    .addCase(extraActions.UpdateLockdownStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
}
